module.exports = __webpack_public_path__ + "img/17.13de72df.png";